import { useTranslation } from '@web_opxp/features';
import maxBy from 'lodash/maxBy';
import { FC } from 'react';
import { connect } from 'react-redux';
import { printShortMonth } from '../../base/dateUtils';
import { EDomain } from '../../base/types';
import { IState } from '../../store/state';
import * as Selectors from '../selectors';
import { IDomainProgress } from '../types';
import './DomainProgress.scss';
import DomainProgressBar from './DomainProgressBar';

export interface IDomainProgressOwnProps {
  domain: EDomain;
}

export interface IDomainProgressProps extends IDomainProgressOwnProps {
  domainResults: IDomainProgress[];
}

export const DomainProgressFC: FC<IDomainProgressProps> = ({ domainResults }) => {
  const { t, language } = useTranslation();

  const maxResult = maxBy(domainResults, 'normalizedScore');
  const maxTimestamp = maxResult ? maxResult.time : -1;

  // pad results with empty values
  const results: IDomainProgress[] = [...domainResults, ...Array(6).fill({ normalizedScore: 0, time: 0 })].slice(0, 6);

  const answerTopLocaId = 'CFQ.Questionnaire.Answers.Never';
  const answerBottomLocaId = 'CFQ.Questionnaire.Answers.VeryOften';
  if (!language) {
    return null;
  }

  return (
    <div className="domain-progress">
      <svg viewBox="0 0 453 164" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(62)">
          <text x="0" y="16" textAnchor="end">
            {t(answerTopLocaId)}
          </text>
          <text x="0" y="143" textAnchor="end">
            {t(answerBottomLocaId)}
          </text>
        </g>
        <g transform="translate(68,8)">
          <rect x="0" y="0" width="1" height="136" className="border" />
          {results.map((progress, index) => (
            <g key={index} transform={`translate(${index * 64})`}>
              <DomainProgressBar
                label={progress.time ? printShortMonth(progress.time, language) : ''}
                value={progress.normalizedScore}
                isMax={maxTimestamp === progress.time}
              />
            </g>
          ))}
        </g>
      </svg>
    </div>
  );
};

const mapStateToProps = (state: IState, ownProps: IDomainProgressOwnProps) => {
  let domainResults: IDomainProgress[] = [];
  if (ownProps.domain) {
    domainResults = Selectors.getDomainResults(state, ownProps.domain);
  }
  return {
    domainResults,
  };
};

const DomainProgress = connect(mapStateToProps)(DomainProgressFC);
export default DomainProgress;
